import * as Icon from "react-bootstrap-icons";
import Checkbox from "../Input/Checkbox";
import dayjs from "dayjs";
import axios from "axios";
import { useState, useEffect } from "react";
import { API_URL } from "../../data/constants";

export default function StatementItem({
                                        statement,
                                        hasCheckbox = false,
                                        setSelectedItem
                                      }) {
  const [isChecked, setIsChecked] = useState(false);

  let userRole = localStorage.getItem("userRole");

  useEffect(() => {
    statement.isSelected = isChecked;
    setSelectedItem(Math.random());
  }, [isChecked]);

  return (
      <div className={`statement-item${statement.isPaid ? "--paid" : ""}`}>
        <div className="statement-item-wrapper">
          <div className="statement-info">
            {hasCheckbox && (
                <Checkbox setIsChecked={setIsChecked} isChecked={isChecked} />
            )}
            <p className="font-weight-bold">#{statement.invoiceNumber}</p>
            <div
                className={`statement-item-payment${
                    statement.paid ? "--paid" : ""
                }`}>
              <p className="statement-amt font-weight-bold">
                ${hasCheckbox ? statement?.balanceRemaining.toFixed(2) : statement?.invoiceTotal.toFixed(2)}
              </p>
              <p className="font-italic">
                {statement.paid
                    ? `Paid on ${statement.date}`
                    : `Due ${dayjs(statement.dueDate).format("MMM D, YYYY")}`}
              </p>
            </div>
          </div>
          <div className="statement-item-select">
            <div className="statement-select-thing" style={{ color: "#0096DB" }}>
              {hasCheckbox && (
                  <>
                    <Checkbox setIsChecked={setIsChecked} isChecked={isChecked} />
                    <p>Select</p>
                  </>
              )}
            </div>
            <p
                className="statement-item-download"
                onClick={() => {
                  axios
                      .post(
                          API_URL + "/Statements/GetPDF",
                          {
                            invoiceNumber: statement.invoiceNumber,
                            statementId: statement.id,
                            userRole: userRole
                          },
                          {
                            headers: {
                              Authorization: localStorage.getItem("accessToken"),
                            },
                          }
                      )
                      .then((res) => {
                        const base64 = res.data.pdf.split(",")[1];
                        const bytes = window
                            .atob(base64)
                            .split("")
                            .map((c) => c.charCodeAt(0));
                        const file = new Blob([new Uint8Array(bytes)], {
                          type: "application/pdf",
                        });
                        const fileURL = URL.createObjectURL(file);
                        const pdfWindow = window.open();
                        pdfWindow.location.href = fileURL;
                      })
                      .catch((error) => {
                        console.error(error);
                      });
                }}>
              Download PDF &nbsp;
              <Icon.FilePdf height={24} width={24} />
            </p>
          </div>
        </div>
      </div>
  );
}
